import { createContext, useContext } from 'react';

export type StickySidebarControls = {
  trackOverhang: (element: HTMLElement | null) => void;
};

const NO_STICKY_SIDEBAR: StickySidebarControls = {
  trackOverhang: () => {},
};

export const StickySidebarContext = createContext<StickySidebarControls | undefined>(undefined);

export const useStickySidebar = (): StickySidebarControls =>
  useContext(StickySidebarContext) ?? NO_STICKY_SIDEBAR;
